import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MdiIcon, Tooltip } from '@mic3/platform-ui';

const TickWrap = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    color: ${({ $read, theme }) => ($read ? theme.material.colors.text.tickRead : theme.material.colors.text.tickUnread)};
    & .MuiIcon-root {
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 1;
        overflow: visible;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    & .MuiIcon-root::before {
        font-size: 16px;
        line-height: 1;
    }
    & svg {
        width: 16px;
        height: 16px;
    }
`;

const MessageReadTick = ({ unread }) => {
    // RC server stamps `unread:true` on send, then $unsets the field once all room
    // members have read. So absent/false → blue; only explicit true → gray.
    const read = unread !== true;
    return (
        <Tooltip title={read ? 'Read' : 'Sent'}>
            <TickWrap $read={read} data-testid="message-read-tick">
                <MdiIcon name="check" fontSize="inherit" />
            </TickWrap>
        </Tooltip>
    );
};

MessageReadTick.propTypes = {
    unread: PropTypes.bool,
};

export default memo(MessageReadTick);
